type Props = {
  index?: string;
  title: string;
  note?: string;
  align?: "start" | "between";
  onMore?: () => void;
};

export default function SectionHeading({ index, title, note, align = "between", onMore }: Props) {
  return (
    <div className={`flex w-full items-end gap-3 border-b-2 border-foreground-950 pb-2 ${align === "between" ? "justify-between" : "justify-start"}`}>
      <div className="flex items-center gap-3">
        {index ? <span className="font-display text-lg text-primary-600">{index}</span> : null}
        <h2 className="whitespace-nowrap font-heading text-lg font-bold tracking-wide text-foreground-950 md:text-xl">
          {title}
        </h2>
      </div>
      <div className="flex flex-1 items-center gap-2">
        {note ? <span className="hidden text-xs text-foreground-400 sm:inline">{note}</span> : null}
      </div>
      {onMore ? (
        <button
          type="button"
          onClick={onMore}
          className="flex cursor-pointer items-center gap-1 whitespace-nowrap text-xs text-foreground-500 transition-colors hover:text-primary-600"
        >
          更多
          <i className="ri-arrow-right-line text-sm" />
        </button>
      ) : null}
    </div>
  );
}